// Get all of the videos
let videos = document.querySelectorAll('[data-youtube]');

// Progressively enhance them
for (let video of videos) {

	// Get the video ID
	let id = new URL(video.href).searchParams.get('v');

	// Add the ID to the data-youtube attribute
	video.setAttribute('data-youtube', id);

	// Add a role of button
	video.setAttribute('role', 'button');

	// Add a thumbnail
	video.innerHTML =
		`
		<svg class="play" width="68px" height="48px" viewBox="0 0 68 48"><path id="play" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg><picture><source srcset="/_/images/video/${id}.webp" type="image/webp"><source srcset="/_/images/video/${id}.jpg" type="image/jpeg"><img loading="lazy" width="720" height="405" src="/_/images/video/${id}.jpg" alt="Play Video."></picture>`;
		
	// Add a thumbnail
	/*video.innerHTML =
		`<img loading="lazy" width="480" height="360" src="https://i.ytimg.com/vi/${id}/hqdefault.jpg" alt="Play Video.">`;
	*/
		

}

/**
 * Handle click events on the video thumbnails
 * @param  {Event} event The event object
 */
 
function clickHandler (event) {

	// Get the video link
	let link = event.target.closest('[data-youtube]');
	if (!link) return;

	// Prevent the URL from redirecting users
	event.preventDefault();

	// Get the video ID
	let id = link.getAttribute('data-youtube');

	// Create the player
	let player = document.createElement('div');
	
	player.classList.add('embed_responsive', 'embed_responsive_16by9');
	
	player.innerHTML = `<iframe class="embed_responsive_item" src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

	// Inject the player into the UI
	link.replaceWith(player);

}

// Detect clicks on the video thumbnails
document.addEventListener('click', clickHandler);